import { removeCommentsFromCss } from './removeCommentsFromCss';
import { replaceFontsAsInline } from './replaceFontsAsInline';
import { replaceRelativeUrlsWithLessRelativePaths } from './replaceRelativeUrlsWithLessRelativePaths';

export const replaceRemoteCssWithStyleTags = (htmlNode: HTMLElement) => {
  const linkTags = htmlNode.querySelectorAll('link[rel="stylesheet"]');
  if (!linkTags.length) return Promise.resolve(htmlNode);

  const promises = Array.from(linkTags).map(linkTag => {
    let cssUrl = linkTag.getAttribute('href');

    if (!cssUrl) return Promise.resolve();

    if (cssUrl?.startsWith('//')) {
      cssUrl = `${window.location.protocol}${cssUrl}`;
    } else if (cssUrl?.startsWith('/')) {
      cssUrl = `${window.location.origin}${cssUrl}`;
    } else if (!cssUrl?.startsWith('http')) {
      cssUrl = `${window.location.href}${cssUrl}`;
    }

    return window
      .proxyFetch(cssUrl, {
        cache: 'force-cache'
      })
      .then(response => response.text())
      .then(css => removeCommentsFromCss(css))
      .then(css => replaceRelativeUrlsWithLessRelativePaths(css, cssUrl))
      .then(css => replaceFontsAsInline(css))
      .then(cssWithFontsInline => {
        const styleTag = document.createElement('style');
        styleTag.textContent = cssWithFontsInline;
        linkTag.parentNode?.replaceChild(styleTag, linkTag);
      })
      .catch(error => {
        // console.error(`Error fetching ${cssUrl}`, error);
        throw error;
      });
  });

  return Promise.all(promises).then(() => {
    return htmlNode;
  });
};
